module.exports = __webpack_public_path__ + "img/chartletBg.1e696439.png";